import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommonModule as NimbusCommonModule } from '../../common/common.module';
import { TopModule } from '../top/top.module';
import { NoteComponent } from './note.component';
import { NoteActionsComponent } from './note-actions.component';
import { VideoPlayerComponent } from './video-player.component';
import { VideoLoaderComponent } from './video-loader.component';
import { AudioPlayerComponent } from './audio-player.component';
import { ImageComponent } from './image.component';
import { AttachmentsComponent } from './attachments.component';
import { AttachmentsListItemComponent } from './attachments-list-item.component';
import { TodosComponent } from './todos.component';
import { TodosPanelComponent } from './todos-panel.component';
import { OverlayLoadingComponent } from './overlay-loading.component';
import { NoteTextComponent } from './note-text.component';
import { TasksManagerPlugin } from './tasks-manager-plugin';
import { NoteTextVersion2Component } from './note-text-version-2.component';

import { VgCoreModule } from "../../../va2/core";
import { VgControlsModule } from "../../../va2/controls";
import { VgOverlayPlayModule } from '../../../va2/overlay-play';
import { MentionService } from './mention.service';
import { NoteImageViewerService } from './noteImageViewer/NoteImageViewer.service';
import { OutlineComponent } from './outlines/outline.component';
import { OutlineItemComponent } from './outlines/outline-item.component';
import { NoteService } from './note.service';
import { OutlineBtnComponent } from './outlines/outline-btn.component';
import { NimWebshareAuthFormModule } from '../../auth-form/auth-form.module';
import { NoteSearchComponent } from "./NoteSearch.component";

@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule,
    RouterModule,
    TopModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    NimWebshareAuthFormModule,
  ],
  declarations: [
    NoteComponent,
    NoteActionsComponent,
    AttachmentsComponent,
    AttachmentsListItemComponent,
    TodosComponent,
    TodosPanelComponent,
    VideoPlayerComponent,
    VideoLoaderComponent,
    AudioPlayerComponent,
    ImageComponent,
    OverlayLoadingComponent,
    NoteTextComponent,
    NoteTextVersion2Component,
    OutlineComponent,
    OutlineItemComponent,
    OutlineBtnComponent,
    NoteSearchComponent,
  ],
  exports: [
    NoteComponent,
    TodosPanelComponent,
    VideoPlayerComponent,
    VideoLoaderComponent,
    AudioPlayerComponent,
    ImageComponent,
    OutlineComponent,
    OutlineItemComponent,
    OutlineBtnComponent,
  ],
  providers: [
    MentionService,
    NoteImageViewerService,
    NoteService,
    TasksManagerPlugin,
  ]
})
export class NoteModule { }
